<div class="check-address_wrapper">
  <div mat-dialog-content>
    <div class="fs-20 mt-5 ml-5 mr-5 mb-3 text-center">{{data.msg}}</div>
  </div>

  <footer mat-dialog-actions class="justify-content-center">
    <button class="btn btn-act btn-xl mr-3" mat-button [mat-dialog-close]="false" cdkFocusInitial>No</button>
    <button class="btn btn-act btn-xl green-btn" mat-button [mat-dialog-close]="true">Yes</button>
  </footer>
</div>
